module.exports = __webpack_public_path__ + "img/FormTemplates.22235439.svg";